import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"white--text ma-2",attrs:{"color":"blue darken-2","depressed":"","small":"","loading":_vm.loading},on:{"click":function($event){return _vm.download(_vm.file)}}},[_vm._v(" Modèle "),_c(VIcon,{attrs:{"right":""}},[_vm._v("mdi-download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }